<template>
  <form id="destination_instagram_form">
    <b-tabs card>
      <b-tab no-body title="افزودن مقصد" active class="mt-2">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                افزودن مقصد
                {{ destinationNames.instagram }}
              </h3>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>نام‌کاربری</label>
              <input
                type="text"
                name="name"
                dir="ltr"
                placeholder="Username"
                v-model="form.name"
                class="form-control"
              />
            </div>
            <!-- <div class="form-group">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="comment_status"
                  true-value="2"
                  false-value="1"
                  v-model="form.details.comment_status"
                />
                <span class="mr-2"></span>
                فعالسازی دیدگاه‌ها
              </label>
            </div> -->
            <div class="form-group">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="rotation"
                  true-value="90"
                  false-value="0"
                  v-model="form.rotation"
                />
                <span class="mr-2"></span>
                چرخش ۹۰ درجه
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="proxy_status"
                  true-value="1"
                  false-value="2"
                  v-model="form.proxy_status"
                />
                <span class="mr-2"></span>
                استفاده از پروکسی
              </label>
            </div>
            <div class="form-group" v-if="isAdmin || isCompany">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="auto_connect"
                  true-value="1"
                  false-value="0"
                  v-model="form.auto_connect"
                />
                <span class="mr-2"></span>
                اتصال خودکار
              </label>
            </div>
            <div class="form-group" v-if="isAdmin || isCompany">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="editable"
                  true-value="1"
                  false-value="0"
                  v-model="form.editable"
                />
                <span class="mr-2"></span>
                فابلیت وبرایش و حدف توسط کاربر
              </label>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab no-body title="آموزش" class="mt-2">
        <img
          width="100%"
          height="100%"
          v-on:mouseover="mouseOverCheck = video.id"
          v-on:mouseout="mouseOverCheck = ''"
          v-bind:src="'/media/user_guides/instagram.gif'"
        />
      </b-tab>
    </b-tabs>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

export default {
  name: "CrInstagramDestination",
  props: {
    isCompany: Boolean,
    isAdmin: Boolean
  },
  data() {
    return {
      form: {
        name: "",
        details: {
          username: "",
          comment_status: "1"
        },
        rotation: "90",
        proxy_status: "1",
        auto_connect: "0",
        editable: "1"
      },
      showPassword: false
    };
  },
  mounted() {
    this.fv = formValidation(
      document.getElementById("destination_instagram_form"),
      {
        fields: {
          name: {
            validators: {
              notEmpty: {
                message: "نام الزامی است"
              }
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      }
    );
  },
  computed: {
    ...mapGetters(["destinationNames"])
  }
};
</script>
